import React from "react";
import Header from "./components/HeaderOneLine";
import Footer from "./components/Footer";
import AppRoutes from "./routes/AppRoutes";
import { logoutUser } from "./redux/authSlice";
import { useSelector, useDispatch } from "react-redux";
import useIdleTimer from "./utils/useIdleTimer";
import RouteChangeHandler from "./utils/RouteChangeHandler";
import { useSearchContext } from "./context/SearchContext";
import AlertWithCloseButton from "./components/Obelisco/AlertWithCloseButton";

function App() {
  const { showModal } = useSearchContext();
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const handleLogout = () => {
    alert("La sesión ha expirado por inactividad.");
    dispatch(logoutUser());
  };

  const { isInactive } = useIdleTimer(handleLogout, isAuthenticated);
  return (
    <>
      <div className="d-flex flex-column min-vh-100">
        <RouteChangeHandler />
        <Header />
        <main className="flex-grow-1">
          <AppRoutes />
        </main>
        {isInactive && <p style={{ color: "red" }}></p>}
        <Footer />
      </div>
      {showModal && <AlertWithCloseButton />}
    </>
  );
}

export default App;
